<template>
  <div>
    <v-row align="center" justify="space-between">
      <v-col cols="2" align="end">
        <v-btn color="primary" fab x-small dark
               @click="lastWeek">
          <v-icon>navigate_before</v-icon>
        </v-btn>
      </v-col>
      <v-col align="center">
        <slot name="datepicker"></slot>
      </v-col>
      <v-col cols="2" align="start">
        <v-btn color="primary" fab x-small dark
               @click="nextWeek">
          <v-icon>navigate_next</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { addWeekToDate, subtractWeekToDate } from '@/lib/dates'
import { toDateOnlyString } from '@/lib/display'

export default {
  props: [
    'value'
  ],
  data () {
    return {
      selectedDate: this.value
    }
  },
  computed: {
    selectedDateValue: {
      get () {
        return this.value || toDateOnlyString(new Date())
      },
      set (value) {
        this.selectedDate = value
      }
    }
  },
  methods: {
    lastWeek () {
      this.selectedDateValue = toDateOnlyString(subtractWeekToDate(this.selectedDateValue, 1))
      this.$emit('selected-weekDate-change', this.selectedDate)
    },
    nextWeek () {
      this.selectedDateValue = toDateOnlyString(addWeekToDate(this.selectedDateValue, 1))
      this.$emit('selected-weekDate-change', this.selectedDate)
    }
  }
}
</script>

<style>

</style>
